import styled from 'styled-components';


export const Wrapper = styled.div`
  background: #FFF;
  color: #323467;
`;